import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=18813e62"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18813e62')) {
      api.createRecord('18813e62', component.options)
    } else {
      api.reload('18813e62', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=18813e62", function () {
      api.rerender('18813e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/Menu.vue"
export default component.exports